'use client'

import { useEffect, useRef } from 'react'
import { useVeritonic } from './VeritonicProvider'

export const FlowStartTracker = () => {
  const { trackFlowStart, isReady } = useVeritonic()
  const hasFired = useRef(false)

  useEffect(() => {
    // Fire the flow-start event exactly once, after the script is ready.
    // `trackFlowStart`'s identity changes with `isReady`, so the ref guards
    // against re-firing if the callback reference changes again later.
    if (!isReady || hasFired.current) return
    hasFired.current = true
    trackFlowStart()
  }, [isReady, trackFlowStart])

  return null
}
